<template>
  <el-backtop :visibility-height="200">
    <i class="iconfont el-icon-arrow-up"></i>
  </el-backtop>
</template>

<script>
export default {
  name: 'BackTop',
};
</script>

<style lang="stylus" scoped>
.el-backtop
  border-radius 4px
  i
    font-size 20px
</style>
